import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "trial-bar overflow-auto" };
const _hoisted_2 = { class: "text-nowrap" };
import { useAuthStore } from '@/stores/auth.ts';
import { computed } from 'vue';
import { langService } from '@/core';
export default /*@__PURE__*/ _defineComponent({
    __name: 'employee-no-plan-bar',
    setup(__props) {
        const authStore = useAuthStore();
        const description = computed(() => {
            var _a, _b, _c;
            if (((_c = (_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.subscription) === null || _c === void 0 ? void 0 : _c.tag) === 'free') {
                return langService.trans('employee.feedback.company_owner_plan_expired');
            }
            return langService.trans('employee.feedback.company_owner_plan_not_include_employees');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(description.value), 1)
            ]));
        };
    }
});
